import { ColumnMeta, Table } from '../../types/components/data-rendering'
import {
  Condition,
  DateModifierKey,
  getDateModifier,
  getOperators,
  Operator,
  OperatorKey,
} from '../../composables/conditionals'
type DefaultConditions = {
  defaultConditions: {
    field: {
      name: string
    } & ColumnMeta
    operation: Operator
    value: any
  }[]
}

export type NewCondition = {
  col: string
  operation: OperatorKey
  value: Condition['value'] | string[]
  dateModifier?: DateModifierKey
  options?: string[]
  optionsKey?: string
}
export type NewConditions = NewCondition[]
type SetDefaultConditionsReturn = {
  meta: Table['meta'] & DefaultConditions
  data: Table['data']
}

/**Sets default filter conditions */
export const setDefaultConditions = (
  data: Table,
  newConditions: NewConditions
): SetDefaultConditionsReturn => {
  //

  const newData: SetDefaultConditionsReturn = {
    meta: { defaultConditions: [], ...data.meta },
    data: data.data,
  }
  newData.meta.defaultConditions = []
  newConditions.forEach((condition) => {
    newData.meta.defaultConditions.push({
      field: { name: condition.col, ...newData.meta.columns[condition.col] },
      operation: getOperators(condition.operation), // should be key, lookup operation from conditionals hook
      value: condition.value,
      ...(condition.dateModifier && { dateModifier: getDateModifier(condition.dateModifier) }), //date modifier
    })
  })

  return newData
}

/**Sets default group/sorting */
export const setGroupSort = (
  data: Table,
  conditions: {
    sortBy?: string
    groupBy?: string
  }
) => {
  const newTable = data
  if (!newTable.meta.defaults) {
    newTable.meta.defaults = {}
  }
  if (conditions.groupBy) {
    newTable.meta.defaults.groupBy = conditions.groupBy
  }
  if (conditions.sortBy) {
    newTable.meta.defaults.sortBy = conditions.sortBy
  }
  return newTable
}
